import { useSelector } from "react-redux";
import Can from "../../util/can";
import { Menu } from "antd";
import { PropTypes } from "prop-types";
import React from "react";

const AdminMenu = (props) => {
  const { resource, children } = props;
  const { authUser } = useSelector(({ auth }) => auth);

  if (authUser && ["Merchant", "Merchant Reports", "Merchant Developer"].includes(authUser.role.name)) {
    return <Can I="read" a=""></Can>;
  };

  return (
    <Can I="read" a={resource}>
      <Menu.Item {...props}>
        {children}
      </Menu.Item>
    </Can>
  )
};

AdminMenu.defaultProps = {
  resource: '',
};

AdminMenu.propTypes = {
  resource: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AdminMenu;
